$(document).ready(function(){
  $('.custom-collection-filter-button a').click(function(){
$('.custom-collection-filters').toggleClass('active');
      if ($(window).width() > 767) {
    setTimeout(function(){
    $('.collection-filter-product-wrapper .product-grid-container .collection').toggleClass('filter-open');
      },250);

      } else {
         $('.collection-filter-product-wrapper .product-grid-container .collection').toggleClass('filter-open');
}
});

$("span.cross_icon").click(function(){

  $(".custom-collection-filter-button a").trigger("click");
});



// Check if the URL contains the specified value
if (window.location.href.indexOf("#whowe") > -1) {
  setTimeout(function() {
    // If the condition is true, find the button with the ID 'vfff' and trigger a click event
  $("a.Who-We-Are").trigger('click');
     }, 200);
}

  const listItems = document.querySelectorAll('.multicolumn-list li');

  // Loop through each <li> and add an onclick event listener
  listItems.forEach(item => {
    item.addEventListener('click', function() {
      // Get the ID from the data-id attribute
      const targetId = item.getAttribute('data-id');
      
      // Find the corresponding div with the matching id
      const targetDiv = document.getElementById(targetId);
      
      // Scroll the page to the target div
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    });
  });



  
});


$(document).ready(function () {
$('.slider-our-prod').slick({
  slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
  infinite:false,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
    arrows:true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false
      }
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
});


  $(document).ready(function(){
            $('.custom-collection-filter-button').click(function(){
                $('body').addClass('show-overlay');
            });

            $('.cross_icon').click(function(){
                $('body').removeClass('show-overlay');
            });
        });

  

$('.icons-wrapper').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


  
  });


$(document).ready(function() {
var offset = 60;
     $("a.about-mean-yafa").click(function () {
        $("html, body").animate({ scrollTop: $("div#meaningyafa").offset().top - offset });
    });
     $("a.essence-logo").click(function () {
        $("html, body").animate({ scrollTop: $("div#aboutnewli").offset().top - offset });
    });
     $("a.rooted-about").click(function () {
        $("html, body").animate({ scrollTop: $("div#signleimage").offset().top - offset });
    });
  $("a.Who-We-Are").click(function () {
        $("html, body").animate({ scrollTop: $("div#whowe").offset().top - offset });
    });

});



$(document).ready(function() {
var offset = 40;
     $("a.mean-yaf-me").click(function () {
        $("html, body").animate({ scrollTop: $("div#meanyafa").offset().top - offset });
    });
     $("a.essnec-mean").click(function () {
        $("html, body").animate({ scrollTop: $("div#Essence").offset().top - offset });
    });
     $("a.spatial-mean").click(function () {
        $("html, body").animate({ scrollTop: $("div#SPATIAL").offset().top - offset });
    });
     $("a.bloom-mean").click(function () {
        $("html, body").animate({ scrollTop: $("div#BLOOM").offset().top - offset });
    });



  
});


$(document).ready(function() {
var offset = 90;
     $("a.garment-duk").click(function () {
        $("html, body").animate({ scrollTop: $("div#garments").offset().top - offset });
    });
     $("a.acces-duk").click(function () {
        $("html, body").animate({ scrollTop: $("div#accessories").offset().top - offset });
    });
     $("a.good-duk").click(function () {
        $("html, body").animate({ scrollTop: $("div#goodies").offset().top - offset });
    });
     $("a.art-duk").click(function () {
        $("html, body").animate({ scrollTop: $("div#art").offset().top - offset });
    });
});



$(document).ready(function() {
    $(".accordion-containercustom .accordiancstmset a").click(function(e) {
        e.preventDefault();
        
        // Check if the clicked item has the "active" class
        if (!$(this).hasClass("active")) {
            // Remove the "active" class from all accordion items
            $(".accordion-containercustom .accordiancstmset a").removeClass("active");
            
            // Add the "active" class to the clicked item
            $(this).addClass("active");
        } else {
            // If the clicked item already has the "active" class, remove it to close the accordion item
            $(this).removeClass("active");
        }
    });



$(window).scroll(function() {
    if ($(this).scrollTop() >= 6 ) {
        $('header.header').addClass('scroll_active');
    } else {
        $('header.header').removeClass('scroll_active');
    }
});



var offset = 110;
    $("a.gift-card-cutom").click(function () {
        $("html, body").animate({ scrollTop: $("div#giftcard").offset().top - offset });
    });
  $("a.craete-one-custm").click(function () {
        $("html, body").animate({ scrollTop: $("div#createown").offset().top - offset });
    });
       $("a.baklava-custm").click(function () {
        $("html, body").animate({ scrollTop: $("div#baklava").offset().top - offset });
    });
       $("a.date-custm").click(function () {
        $("html, body").animate({ scrollTop: $("div#datacollection").offset().top - offset });
    });
       $("a.cookie-custm").click(function () {
        $("html, body").animate({ scrollTop: $("div#cookiescoll").offset().top - offset });
    });
       $("a.trad_sweet").click(function () {
        $("html, body").animate({ scrollTop: $("div#trad_sweetscoll").offset().top - offset });
    });  
  
});


 // $(document).ready(function () {
 //        $('#custom-account-trigger').click(function () {
 //            $('.acconut-custm-open').toggle();
 //        });
 //    });

$(document).ready(function () {
    // Hide the popup initially
    $('.acconut-custm-open').hide();

    // Toggle popup when clicking the trigger
    $('#custom-account-trigger').click(function (event) {
        $('.acconut-custm-open').toggle();
        // Prevent default action of the trigger anchor tag
        event.preventDefault();
        // Stop the event from propagating to the document click event
        event.stopPropagation();
    });

    // Close the popup when clicking outside of it
    $(document).click(function (event) {
        // Check if the clicked element is not the trigger or the popup
        if (!$(event.target).closest('#custom-account-trigger').length && !$(event.target).closest('.acconut-custm-open').length) {
            // Hide the popup
            $('.acconut-custm-open').hide();
        }
    });
});





$(document).ready(function() {
var offset = 300;
     $("a.email").click(function () {
        $("html, body").animate({ scrollTop: $("div#emailcont").offset().top - offset });
    });
     $("a.call").click(function () {
        $("html, body").animate({ scrollTop: $("div#callcont").offset().top - offset });
    });
     $("a.visit").click(function () {
        $("html, body").animate({ scrollTop: $("div#visitncont").offset().top - offset });
    });
    $("a.noise").click(function () {
        $("html, body").animate({ scrollTop: $("div#noise-custm").offset().top - offset });
    });
});



function getLastVariantValue() {
 $(".variant-library-container .variant-value:first-child").addClass("open-size");
    setTimeout(function() {
        var url = window.location.href;
        var lastValueIndex = url.lastIndexOf('variant=');
        
        if (lastValueIndex !== -1) {
            var lastValue = url.substring(lastValueIndex + 8);
            
           
            $(".variant-library-container .variant-value").each(function(){
                var attribute_id = $(this).attr('data-id');
                if (attribute_id === lastValue) {
                    $(this).addClass('open-size');
                    $(this).siblings().removeClass('open-size');
                }
            });
        } else {
            console.log('No variant value found in the URL');
        }
    }, 1); // 0.5 seconds timeout
}


  // Add event listener to the select element
  $(document).ready(function() {
    $('.product-form__input.product-form__input--dropdown .select__select').change(getLastVariantValue);
  });

// Execute on page load
$(document).ready(function() {
    getLastVariantValue();
});

var btn = $('#buttoncustom');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});



// Buy it now 

  $("#checkoutButtonLink button").click(function() {
        var productId = $("input.product-variant-id").val();
        var quantity = $("input.quantity__input.but-it-now").val();
        
        var formData = {
            items: [{
                id: productId,
                quantity: quantity
            }]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This header is required for Shopify AJAX requests
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            // Redirect to the checkout page
            window.location.href = '/checkout';
        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
        });
    });

 const videos = document.querySelectorAll(".custom-video");
  // Get all circle play buttons
  const playButtons = document.querySelectorAll(".cstm-requirment");
  // Add click event listener to each play button
  playButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      const video = videos[index];
      if (video.paused) {
        video.play();
        button.style.opacity = 0;
      } else {
        video.pause();
        button.style.opacity = 1;
      }
    });
  });



 const videos_custom = document.querySelectorAll(".custom-video-best");
  // Get all circle play buttons
  const playButtons_custom = document.querySelectorAll(".cstm-requirment-best");
  // Add click event listener to each play button
  playButtons_custom.forEach((button, index) => {
    button.addEventListener("click", () => {
      const video_custom = videos_custom[index];
      if (video_custom.paused) {
        video_custom.play();
        button.style.opacity = 0;
      } else {
        video_custom.pause();
        button.style.opacity = 1;
      }
    });
  });




$(document).ready(function(){
    // Add button inside the specified div after a delay of 2 seconds
    setTimeout(function() {
        $(".grp-entangle-swiper-main.grp-entangle-layout-body-wrapper").append('<div class="custom-viw-all-review"><a target="_blank" href="https://www.google.com/maps/search/?api=1&amp;query=Google&amp;query_place_id=ChIJnetUFwl344kRBBNujdU-yGo">View All Reviews</a></div>');
    }, 2000); // 2000 milliseconds = 2 seconds
});


 $(".custom-title-pop").click(function(event){
        event.preventDefault(); // Prevent default link behavior
        $(".custom-title-pop").removeClass("active"); // Remove active class from all links
        $(this).addClass("active"); // Add active class to clicked link
    });


 $(".custom-title-pop").click(function(event){
        event.preventDefault(); // Prevent default link behavior
        $("body").addClass("custom-pop-up"); // Add active class to clicked link
    });
 $(".close-button").click(function() {
                 $("body").removeClass("custom-pop-up"); // Hide the parent pop-up when close button is clicked
            });





function getpeaciesValue() {
  $(".custom-heading-includes .variant-value-text:nth-child(2)").addClass("open-text");
    setTimeout(function() {
        var urlcustom = window.location.href;
        var lastValueIndexcustom = urlcustom.lastIndexOf('variant=');
        
        if (lastValueIndexcustom !== -1) {
            var lastValuecustom = urlcustom.substring(lastValueIndexcustom + 8);
            
           
            $(".custom-heading-includes .variant-value-text").each(function(){
                var attribute_idcustom = $(this).attr('data-id');
                if (attribute_idcustom === lastValuecustom) {
                    $(this).addClass('open-text');
                    $(this).siblings().removeClass('open-text');
                }
            });
        } else {
            console.log('No variant value found in the URL');
        }
    }, 1);
}

  $(document).ready(function() {
    $('.product-form__input.product-form__input--dropdown .select__select').change(getpeaciesValue);
  });

// Execute on page load
$(document).ready(function() {
    getpeaciesValue();
});




$(document).ready(function() {
    $(".variant-library-container .variant-value a.custom-title-pop").on("click", function(e) {
        e.preventDefault(); // Click event ka default behavior ko rokna

        $(".variant-library-container .variant-value a.custom-title-pop").removeClass("active");

        $(this).addClass("active");

        var dataValue = $(this).data("value");

        $(".pop-up-made-cosnt-main-wrapper").removeClass("active");
        $(".pop-up-made-cosnt-main-wrapper[data-value='" + dataValue + "']").addClass("active");
    });  
    $(".pop-up-made-cosnt-main-wrapper .close-button").on("click", function() {
        $(".variant-library-container .variant-value a").removeClass("active");
        $(".pop-up-made-cosnt-main-wrapper").removeClass("active");
    });
});


$(document).ready(function() {
    $(".product-form__input .quantity__input").addClass("but-it-now");
});


$(document).ready(function() {
    $('input#Recipient-checkbox-template--16522395877537__main').click(function() {
        $('product-form.product-form .product-form__error-message-wrapper').toggleClass('collabes-check');
    });
});


// Function to generate breadcrumb
function generateBreadcrumb() {
    var breadcrumb = document.getElementById('breadcrumb');
    var currentURL = window.location.pathname; // Only get URL path
    var pathArray = currentURL.split('/').filter(Boolean); // Split URL path and remove empty elements
    var breadcrumbHTML = '';

    // Add Home breadcrumb
    breadcrumbHTML += '<a href="/">Home</a>';

    // Get current URL from session storage
    var storedURL = sessionStorage.getItem('currentURL');

    // If current URL is different from stored URL, update session storage with current URL
    if (storedURL !== currentURL) {
        // Store both current and previous URLs in session storage
        sessionStorage.setItem('previousURL', storedURL);
        sessionStorage.setItem('currentURL', currentURL);
    }

    // Get previous URL from session storage
    var previousURL = sessionStorage.getItem('previousURL');

    // If previous URL exists and is not equal to current URL, generate breadcrumbs for previous URL
    if (previousURL && previousURL !== currentURL) {
        var previousPathArray = previousURL.split('/').filter(Boolean);

        // Loop through previousPathArray to create breadcrumbs for previous URL
        for (var i = 0; i < previousPathArray.length; i++) {
            if (previousPathArray[i].toLowerCase() !== 'pages' && previousPathArray[i].toLowerCase() !== 'collections' && previousPathArray[i].toLowerCase() !== 'products' && previousPathArray[i].toLowerCase() !== 'null') {
                var title = previousPathArray[i].charAt(0).toUpperCase() + previousPathArray[i].slice(1);
                breadcrumbHTML += ' / <a href="/' + previousPathArray.slice(0, i + 1).join('/') + '">' + title.replace(/-/g, ' ') + '</a>';
            }
        }
    }

    // If current page is not the root page
    if (pathArray.length > 1) {
        // Get the last segment of the URL (current page name)
        var currentPage = pathArray[pathArray.length - 1];
        breadcrumbHTML += ' / <span>' + currentPage.replace(/-/g, ' ') + '</span>'; // Use span instead of anchor tag for current page
    }

    // Update breadcrumb div with generated breadcrumbs
    breadcrumb.innerHTML = breadcrumbHTML;
}

// Call generateBreadcrumb function when page loads
window.onload = function () {
    generateBreadcrumb();

    // Store current URL in session storage
    var currentURL = window.location.pathname;
    sessionStorage.setItem('currentURL', currentURL);
};

$(document).ready(function(){
    $(".footer-block:first-of-type ul.footer-block__details-content li:nth-child(5) a").attr("target", "_blank");
});
$(document).ready(function(){
    $(".footer-block:first-of-type ul.footer-block__details-content li:nth-child(4) a").attr("target", "_blank");
});


$(document).ready(function() {
    $('.product__pickup-availabilities').insertAfter('#checkoutButtonLink');
});

$('.custom-section-also-may').slick({
  slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
  infinite:false,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
    arrows:true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false
      }
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
});